module.exports = __webpack_public_path__ + "img/v1.c7a422c4.png";